import type { App } from 'vue'
import Vue3Toastify, { type ToastContainerOptions, toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default function (app: App) {
  app.use(Vue3Toastify, {
    autoClose: 3000,
    position: 'top-right',
    transition: 'slide',
    theme: 'light',
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    draggable: true,
    rtl: false,
  } as ToastContainerOptions)

  // Make toast available globally
  app.config.globalProperties.$toast = toast
}

// Export toast for use in composables
export { toast }
